import { HOW_IT_WORKS_STEPS } from 'modules/jogador/home/content';
import { Reveal } from 'shared/components/motion/Reveal';
import { StaggerGroup, StaggerItem } from 'shared/components/motion/Stagger';

export function HowItWorksSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-10">
      <Reveal className="text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-chip px-4 py-1.5 text-sm font-medium text-ink-secondary">
          Como funciona
        </span>
        <h2 className="mt-3 font-heading text-2xl font-bold text-ink">Do achar quadra ao rachar o Pix</h2>
      </Reveal>

      <StaggerGroup className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {HOW_IT_WORKS_STEPS.map((step, index) => (
          <StaggerItem
            key={step.id}
            className="group relative h-full rounded-2xl border border-border/60 bg-surface p-5 shadow-card transition-all duration-300 hover:-translate-y-1 hover:border-primary/40 hover:shadow-card-hover"
          >
            <span className="absolute -top-3 left-5 flex h-7 w-7 items-center justify-center rounded-full bg-primary text-xs font-bold text-surface shadow-glow">
              {index + 1}
            </span>
            <span className="mt-2 flex h-11 w-11 items-center justify-center rounded-xl bg-accent-soft text-primary-dark transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-110">
              <step.icon className="h-5 w-5" aria-hidden="true" />
            </span>
            <h3 className="mt-3 font-heading text-base font-semibold text-ink">{step.title}</h3>
            <p className="mt-1.5 text-sm text-ink-secondary">{step.description}</p>
          </StaggerItem>
        ))}
      </StaggerGroup>
    </section>
  );
}
